const SHOW_ASIDE_MENU = "SHOW_ASIDE_MENU";
const CHANGE_HEADER = "CHANGE_HEADER";

export { SHOW_ASIDE_MENU, CHANGE_HEADER };
